import { useRef, useState, useEffect } from 'react'
import styles from './IFSegmentedControl.module.css'
import IFText from 'Components/IFText/IFText'

const IFSegmentedControl = ({
  name,
  segments,
  callback,
  defaultIndex = 0,
  controlRef,
  isLoading,
}) => {
  const [activeIndex, setActiveIndex] = useState(defaultIndex)
  const componentReady = useRef()

  useEffect(() => {
    if (!isLoading) {
      componentReady.current = true
    }
  }, [isLoading])

  useEffect(() => {
    if (isLoading || !segments?.length) return

    const activeSegmentRef = segments[activeIndex]?.ref
    if (!activeSegmentRef?.current || !controlRef?.current) return

    const { offsetWidth, offsetLeft } = activeSegmentRef.current
    const { style } = controlRef.current

    style.setProperty('--highlight-width', `${offsetWidth}px`)
    style.setProperty('--highlight-x-pos', `${offsetLeft}px`)
  }, [activeIndex, callback, controlRef, segments, isLoading])

  const onInputChange = (value, index) => {
    setActiveIndex(index)
    callback(value, index)
  }

  return (
    <div
      className={styles.controlsContainer}
      ref={!isLoading ? controlRef : null}
    >
      <div
        className={`${styles.controls} ${
          !isLoading && componentReady.current ? styles.ready : ''
        } ${isLoading ? styles.loading : ''}`}
      >
        {isLoading
          ? segments.map((_, i) => (
              <div key={i} className={styles.segment}>
                <div className={styles.skeletonText} />
              </div>
            ))
          : segments.map((item, i) => (
              <div
                key={item.value}
                className={`${styles.segment} ${
                  i === activeIndex ? styles.active : ''
                }`}
                ref={item.ref}
              >
                <input
                  type="radio"
                  value={item.value}
                  id={item.label}
                  name={name}
                  onChange={() => onInputChange(item.value, i)}
                  checked={i === activeIndex}
                />
                <label htmlFor={item.label}>
                  <IFText>{item.label}</IFText>
                </label>
              </div>
            ))}
      </div>
    </div>
  )
}

export default IFSegmentedControl
